/* ============================================
   PRELOADER
   ============================================ */

(function() {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;

  // Skip preloader if already seen
  if (localStorage.getItem('nymphai_preloader_seen')) {
    preloader.remove();
    document.body.style.overflow = '';
    ScrollTrigger.refresh();
    const navEl = document.querySelector('.dett-nav');
    const bottomEl = document.querySelector('.dett-hero__bottom');
    if (navEl) navEl.style.opacity = '1';
    if (bottomEl) bottomEl.style.opacity = '1';
    // queueMicrotask: aspetta che tutti gli IIFE in main.js finiscano di registrarsi,
    // senza nessun frame visibile (zero delay percepito)
    queueMicrotask(function() {
      window.dispatchEvent(new CustomEvent('preloader-done'));
    });
    return;
  }

  const img = document.getElementById('preloader-img');
  const words = [document.getElementById('preword1'), document.getElementById('preword2')];

  // Split words into letter spans
  words.forEach(wordEl => {
    const letters = wordEl.textContent.split('');
    wordEl.textContent = '';
    letters.forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      wordEl.appendChild(span);
    });
  });

  // Images to cycle — use Shopify CDN URLs from __NYMPHAI_ASSETS__ if available
  const _a = window.__NYMPHAI_ASSETS__ || {};
  const images = [
    _a.preloaderCrema || 'images/preloader/crema.webp',
    _a.preloaderDonne || 'images/preloader/donne.webp',
    _a.preloaderLatte || 'images/preloader/latte.webp',
  ];

  // Wait for Quasimoda font to load before starting animation
  function startPreloaderAnimation() {
    gsap.to('.preloader__word span', {
      y: 0,
      duration: 0.8,
      ease: 'power3.out',
      stagger: 0.05,
      onComplete: () => {
        gsap.to(img, {
          width: window.innerWidth < 768 ? 80 : 150,
          duration: 1,
          ease: 'power1.inOut',
          onComplete: () => {
            let index = 0;
            const showNextImage = () => {
              if (index < images.length) {
                img.src = images[index];
                index++;
                setTimeout(showNextImage, 800);
              } else {
                exitPreloader();
              }
            };
            showNextImage();
          },
        });
      },
    });
  }

  // Wait for font, but start after 3s max to avoid infinite wait if font fails
  let animationStarted = false;
  function tryStart() {
    if (animationStarted) return;
    animationStarted = true;
    startPreloaderAnimation();
  }
  const fontTimeout = setTimeout(tryStart, 3000);
  document.fonts.ready.then(() => {
    clearTimeout(fontTimeout);
    tryStart();
  });

  function exitPreloader() {
    const tl = gsap.timeline({ defaults: { ease: 'power3.inOut', duration: 0.8 } });

    tl.to('.preloader__word span', { y: -100, opacity: 0, stagger: 0.03 })
      .to(img, { y: -100, opacity: 0 }, '<')
      .to(preloader, { opacity: 0, duration: 0.5, onComplete: () => {
        preloader.remove();
        document.body.style.overflow = '';
        ScrollTrigger.refresh();
        localStorage.setItem('nymphai_preloader_seen', '1');
        // Animate nav and bottom bar in after preloader
        const navEl = document.querySelector('.dett-nav');
        const bottomEl = document.querySelector('.dett-hero__bottom');
        if (navEl) gsap.to(navEl, { opacity: 1, duration: 0.8, ease: 'power2.out' });
        if (bottomEl) gsap.to(bottomEl, { opacity: 1, duration: 0.8, ease: 'power2.out' });
        window.dispatchEvent(new CustomEvent('preloader-done'));
      }}, '+=0.2');
  }
})();

/* ============================================
   LANGUAGE MENU DROPDOWN (tablet/mobile)
   ============================================ */

(function() {
  document.querySelectorAll('.lang-menu').forEach(function(menu) {
    var active = menu.querySelector('.lang-menu__active');
    if (!active) return;

    active.addEventListener('click', function(e) {
      e.stopPropagation();
      menu.classList.toggle('is-open');
    });
  });

  document.addEventListener('click', function() {
    document.querySelectorAll('.lang-menu.is-open').forEach(function(m) {
      m.classList.remove('is-open');
    });
  });
})();

/* ============================================
   LANGUAGE SWITCHER TRANSITION
   ============================================ */

(function() {
  // Crea overlay
  const overlay = document.createElement('div');
  overlay.className = 'lang-overlay';
  document.body.appendChild(overlay);

  // Se la pagina si è caricata dopo un cambio lingua → fade-out overlay
  if (sessionStorage.getItem('lang_transitioning')) {
    sessionStorage.removeItem('lang_transitioning');
    overlay.style.opacity = '1';
    overlay.style.transition = 'none';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.style.transition = 'opacity 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
        overlay.style.opacity = '0';
      });
    });
  }

  // Intercetta click sui pulsanti lingua (nuovo lang-menu + vecchio lang-btn)
  document.querySelectorAll('.lang-menu__option, .lang-btn:not(.is-active)').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      sessionStorage.setItem('lang_transitioning', '1');
      overlay.classList.add('fade-in');
      var form = btn.closest('form');
      var hidden = form.querySelector('input[name="locale_code"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'locale_code';
        form.appendChild(hidden);
      }
      hidden.value = btn.value;
      setTimeout(function() { form.submit(); }, 380);
    });
  });
})();

/* ============================================
   HERO PORTRAIT DETECTION
   ============================================ */
(function() {
  const hero = document.querySelector('.slideshow-hero');
  if (!hero) return;
  let swapped = false;

  function swapHeadings() {
    const leftWraps = hero.querySelectorAll('.left-container [data-slideshow="slide-left-wrap"]');
    const rightWraps = hero.querySelectorAll('.right-container [data-slideshow="slide-right-wrap"]');
    leftWraps.forEach((lw, i) => {
      const rw = rightWraps[i];
      if (!rw) return;
      const lc = lw.querySelector('.slide_content');
      const rc = rw.querySelector('.slide_content');
      if (lc && rc) {
        lw.appendChild(rc);
        rw.appendChild(lc);
      }
    });
    swapped = !swapped;
  }

  function checkRatio() {
    const isPortrait = window.innerHeight > window.innerWidth * (6 / 5);
    hero.classList.toggle('hero--portrait', isPortrait);
    if (isPortrait && !swapped) swapHeadings();
    else if (!isPortrait && swapped) swapHeadings();
  }

  // Run after slideshow restructures DOM
  const observer = new MutationObserver(() => {
    if (hero.querySelector('.left-container')) {
      observer.disconnect();
      checkRatio();
    }
  });
  observer.observe(hero, { childList: true, subtree: true });
  window.addEventListener('resize', checkRatio);
})();

/* ============================================
   GSAP PLUGINS
   ============================================ */

gsap.registerPlugin(ScrollTrigger, Observer, CustomEase, Flip, Draggable);
if (typeof InertiaPlugin !== 'undefined') gsap.registerPlugin(InertiaPlugin);

CustomEase.create(
  'expoDecay',
  'M0,0 C0.126,0.382 0.282,0.674 0.44,0.822 0.632,1.002 0.818,1.001 1,1'
);

/* ============================================
   LENIS SMOOTH SCROLL
   ============================================ */

const lenis = new Lenis({
  duration: 1.8,
  lerp: 0.05,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  orientation: 'vertical',
  gestureOrientation: 'vertical',
  smoothWheel: true,
  wheelMultiplier: 0.9,
  touchMultiplier: 2,
});

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

window.lenis = lenis;

/* ============================================
   CUSTOM CURSOR — Dot + Ring
   ============================================ */

(function () {
  var cursorEl = document.getElementById('cursor');
  if (!cursorEl) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  var ring = cursorEl.querySelector('.Cursor__ring');
  var dot  = cursorEl.querySelector('.Cursor__dot');
  if (!ring || !dot) return;

  var mouseX = window.innerWidth  / 2;
  var mouseY = window.innerHeight / 2;
  var ringX  = mouseX;
  var ringY  = mouseY;

  window.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.style.transform = 'translate3d(' + mouseX + 'px,' + mouseY + 'px,0) translate(-50%,-50%)';
  });

  (function tick() {
    ringX += (mouseX - ringX) * 0.10;
    ringY += (mouseY - ringY) * 0.10;
    ring.style.transform = 'translate3d(' + ringX + 'px,' + ringY + 'px,0) translate(-50%,-50%)';
    requestAnimationFrame(tick);
  })();

  var hoverState = 'default';

  function setCursorState(state) {
    if (hoverState === state) return;
    hoverState = state;
    cursorEl.classList.remove('Cursor--image', 'Cursor--link');
    if (state === 'link')  cursorEl.classList.add('Cursor--link');
    if (state === 'image') cursorEl.classList.add('Cursor--image');
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (t.closest('a, button, [role="button"]')) {
      setCursorState('link');
    } else if (t.closest('img, video, svg image, .dett-filter-img, .dett-filter-video')) {
      setCursorState('image');
    } else {
      setCursorState('default');
    }
  });
})();

/* ============================================
   BURGER MENU — Circular reveal overlay
   ============================================ */

(function () {
  var burger = document.getElementById('dett-burger');
  var overlay = document.getElementById('dett-menu-overlay');
  if (!burger || !overlay) return;

  var bg = overlay.querySelector('.dett-menu-overlay__bg');
  var links = overlay.querySelectorAll('.dett-menu-overlay__link');
  var subLinks = Array.from(overlay.querySelectorAll('.overlay-sub__link, .overlay-sub__linea'));
  var bottom = overlay.querySelector('.dett-menu-overlay__bottom');
  var image = overlay.querySelector('.dett-menu-overlay__image');
  var bars = burger.querySelectorAll('.dett-burger__bar');
  var isOpen = false;

  if (subLinks.length) gsap.set(subLinks, { clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 30 });

  var tl = gsap.timeline({
    paused: true,
    defaults: { ease: 'power3.out' },
    onReverseComplete: function () {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('inert', '');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    },
  });

  tl.to(bg, { clipPath: 'circle(150% at 40px 40px)', duration: 0.9, ease: 'power4.inOut' }, 0);
  tl.to(bars[0], { rotation: 45, y: 3.75, duration: 0.4, ease: 'power2.inOut' }, 0);
  tl.to(bars[1], { rotation: -45, y: -3.75, duration: 0.4, ease: 'power2.inOut' }, 0);
  tl.fromTo(links, {
    clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 30
  }, {
    clipPath: 'inset(0% 0 0 0)', opacity: 1, y: 0,
    stagger: 0.07, duration: 0.6, ease: 'power2.out'
  }, 0.35);
  if (bottom) tl.fromTo(bottom, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.5 }, 0.7);
  if (image) tl.fromTo(image, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.6 }, 0.5);
  if (subLinks.length) tl.to(subLinks, { clipPath: 'inset(0% 0 0 0)', opacity: 1, y: 0, duration: 0.6, stagger: 0.07, ease: 'power2.out' }, 0.49);

  function openMenu() {
    isOpen = true;
    burger.classList.add('is-open');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    burger.setAttribute('aria-expanded', 'true');
    lenis.stop();
    if (subLinks.length) gsap.set(subLinks, { clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 30 });
    tl.timeScale(1).play();
  }

  function closeMenu() {
    isOpen = false;
    burger.classList.remove('is-open');
    lenis.start();
    tl.timeScale(1.4).reverse();
  }

  burger.addEventListener('click', function () {
    if (isOpen) closeMenu();
    else openMenu();
  });

  links.forEach(function (link) {
    link.addEventListener('click', function () { if (isOpen) closeMenu(); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeMenu();
  });
})();

/* ============================================
   NAV SCROLL DETECTION
   ============================================ */

(function () {
  var nav = document.querySelector('.dett-nav');
  if (!nav) return;

  ScrollTrigger.create({
    start: 100,
    onUpdate: function (self) {
      if (self.direction === 1 && self.scroll() > 100) {
        nav.classList.add('is-scrolled');
      } else if (self.scroll() < 100) {
        nav.classList.remove('is-scrolled');
      }
    },
  });
})();

/* ---------- NAV su footer — versione scura ---------- */
(function () {
  var nav = document.querySelector('.dett-nav');
  var bottom = document.querySelector('.dett-hero__bottom');
  var footer = document.querySelector('.footer');
  if (!nav || !footer) return;
  function addDark()    { nav.classList.add('is-on-footer');    if (bottom) bottom.classList.add('is-on-footer'); }
  function removeDark() { nav.classList.remove('is-on-footer'); if (bottom) bottom.classList.remove('is-on-footer'); }
  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom top',
    onEnter:     addDark,
    onLeaveBack: removeDark,
    onLeave:     removeDark,
  });
})();

/* ============================================
   SLIDESHOW MANAGER (from slide/dist/script.js)
   ============================================ */

const ANIMATION = {
  DURATION: {
    MIDDLE_CLIP: 0.5,
    SIDE_CLIP: 1.25,
    SCALE: 1,
    TEXT: 0.75,
  },
  TIMING: {
    SIDE_DELAY: 0.25,
    TEXT_STAGGER: 0.035,
    TEXT_RIGHT_DELAY: 0.35,
  },
  TRANSFORM: {
    SCALE: 1.25,
    SIDE_MOVEMENT: 30,
    TEXT_OFFSET: 150,
  },
};

const wrapIndex = (index, length) => ((index % length) + length) % length;

class SlideshowManager {
  constructor() {
    this.state = {
      currentIndex: 0,
      isAnimating: false,
      totalSlides: 0,
      direction: 0,
    };
    this.initialElements = null;
    this.elements = null;
    this.tl = null;
    this.observer = null;
    this.isReleased = false;
    this.canReengage = false;
  }

  init() {
    this.setupInitialElements();
    this.extractContainers();
    this.setupSlideElements();
    this.initializeSlideStates();
    this.setupInteraction();
    this.setupScrollLock();
  }

  setupInitialElements() {
    this.container = document.querySelector('[data-slideshow="container"]');
    this.initialElements = {
      slides: this.container.querySelectorAll('[data-slideshow="slide"]'),
      slidesCenterWrap: this.container.querySelectorAll('[data-slideshow="slide-center-wrap"]'),
      slidesLeftWrap: this.container.querySelectorAll('[data-slideshow="slide-left-wrap"]'),
      slidesRightWrap: this.container.querySelectorAll('[data-slideshow="slide-right-wrap"]'),
      slidesExploreContainer: this.container.querySelectorAll('[data-slideshow="slide-explore-container"]'),
    };
    this.state.totalSlides = this.initialElements.slides.length;
  }

  createContainer(className) {
    const container = document.createElement('div');
    container.className = className;
    return container;
  }

  extractContainers() {
    const containers = {
      center: this.createContainer('center-container'),
      left: this.createContainer('left-container'),
      right: this.createContainer('right-container'),
    };
    const extractElements = (elements, container) => {
      elements.forEach((element) => {
        const clone = element.cloneNode(true);
        element.remove();
        container.appendChild(clone);
      });
    };
    extractElements(this.initialElements.slidesCenterWrap, containers.center);
    extractElements(this.initialElements.slidesLeftWrap, containers.left);
    extractElements(this.initialElements.slidesRightWrap, containers.right);
    extractElements(this.initialElements.slidesExploreContainer, containers.center);
    Object.values(containers).forEach((container) => {
      this.container.prepend(container);
    });

    // Find existing Explore CTAs from HTML
    this.exploreCtas = Array.from(this.container.querySelectorAll('.slide_explore-cta'));
    this.exploreCtas.forEach((cta, i) => {
      if (i !== 0) gsap.set(cta, { autoAlpha: 0 });
    });
  }

  setupSlideElements() {
    this.elements = {
      slidesCenter: this.container.querySelectorAll('[data-slideshow="slide-center-wrap"]'),
      slidesLeft: this.container.querySelectorAll('[data-slideshow="slide-left-wrap"]'),
      slidesRight: this.container.querySelectorAll('[data-slideshow="slide-right-wrap"]'),
      slidesCenterImg: this.container.querySelectorAll('[data-slideshow="slide-center-wrap"] img'),
      slidesLeftImg: this.container.querySelectorAll('[data-slideshow="slide-left-wrap"] img'),
      slidesRightImg: this.container.querySelectorAll('[data-slideshow="slide-right-wrap"] img'),
      slidesLeftHeading: gsap.utils
        .toArray('[data-slideshow="slide-right-heading"]')
        .map((item) => new SplitType(item, { types: 'chars' })),
      slidesRightHeading: gsap.utils
        .toArray('[data-slideshow="slide-left-heading"]')
        .map((item) => new SplitType(item, { types: 'chars' })),
    };
  }

  initializeSlideStates() {
    this.initialElements.slides.forEach((element) => element.remove());
    for (let i = 0; i < this.state.totalSlides; i++) {
      gsap.set(
        [
          this.elements.slidesCenter[i],
          this.elements.slidesRight[i],
          this.elements.slidesLeft[i],
        ],
        { position: 'absolute' }
      );
    }
    for (let i = 1; i < this.state.totalSlides; i++) {
      gsap.set(this.elements.slidesCenter[i], {
        clipPath: 'inset(50% 50% 50% 50%)',
      });
      gsap.set(this.elements.slidesRight[i], {
        clipPath: 'inset(0% 100% 0% 0%)',
      });
      gsap.set(this.elements.slidesLeft[i], {
        clipPath: 'inset(0% 0% 0% 100%)',
      });
    }
  }

  setSlideZIndexes(nextIndex) {
    const isForward = this.state.direction > 0;
    for (let i = 0; i < this.state.totalSlides; i++) {
      gsap.set(
        [
          this.elements.slidesLeft[i],
          this.elements.slidesRight[i],
          this.elements.slidesCenter[i],
        ],
        { zIndex: null }
      );
    }
    if (isForward) {
      gsap.set(
        [
          this.elements.slidesLeft[nextIndex],
          this.elements.slidesRight[nextIndex],
        ],
        { zIndex: 2 }
      );
      gsap.set(
        [
          this.elements.slidesLeft[this.state.currentIndex],
          this.elements.slidesRight[this.state.currentIndex],
        ],
        { zIndex: 1 }
      );
      gsap.set(this.elements.slidesCenter[nextIndex], { zIndex: 4 });
      gsap.set(this.elements.slidesCenter[this.state.currentIndex], { zIndex: 3 });
    } else {
      gsap.set(
        [
          this.elements.slidesLeft[nextIndex],
          this.elements.slidesRight[nextIndex],
        ],
        { zIndex: 1 }
      );
      gsap.set(
        [
          this.elements.slidesLeft[this.state.currentIndex],
          this.elements.slidesRight[this.state.currentIndex],
        ],
        { zIndex: 2 }
      );
      gsap.set(this.elements.slidesCenter[nextIndex], { zIndex: 3 });
      gsap.set(this.elements.slidesCenter[this.state.currentIndex], { zIndex: 4 });
    }
  }

  createSlideAnimation(nextIndex) {
    this.setSlideZIndexes(nextIndex);
    this.tl = gsap.timeline({
      ease: 'expoDecay',
      onComplete: () => {
        this.state.currentIndex = nextIndex;
        this.state.isAnimating = false;
      },
    });
    // Fade out current CTA, fade in next CTA
    this.tl.to(this.exploreCtas[this.state.currentIndex], { autoAlpha: 0, duration: 0.3 }, 0);
    this.tl.to(this.exploreCtas[nextIndex], { autoAlpha: 1, duration: 0.3 }, 0.4);

    if (this.state.direction > 0) {
      this.createForwardTimeline();
    } else {
      this.createBackwardTimeline();
    }
  }

  createForwardTimeline() {
    const { DURATION, TIMING, TRANSFORM } = ANIMATION;
    const nextIndex = wrapIndex(this.state.currentIndex + 1, this.state.totalSlides);
    this.tl
      .fromTo(
        this.elements.slidesCenter[nextIndex],
        { clipPath: 'inset(50% 50% 50% 50%)' },
        { clipPath: 'inset(0% 0% 0% 0%)', duration: DURATION.MIDDLE_CLIP },
        0
      )
      .fromTo(
        this.elements.slidesCenterImg[nextIndex],
        { scale: 1 },
        { scale: TRANSFORM.SCALE, duration: DURATION.SCALE },
        0
      )
      .fromTo(
        [this.elements.slidesLeft[nextIndex], this.elements.slidesRight[nextIndex]],
        {
          clipPath: (index) =>
            index === 0 ? 'inset(0% 0% 0% 100%)' : 'inset(0% 100% 0% 0%)',
        },
        { clipPath: 'inset(0% 0% 0% 0%)', duration: DURATION.SIDE_CLIP },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        [this.elements.slidesLeftImg[nextIndex], this.elements.slidesRightImg[nextIndex]],
        {
          xPercent: (index) =>
            index === 0 ? TRANSFORM.SIDE_MOVEMENT : -TRANSFORM.SIDE_MOVEMENT,
        },
        { xPercent: 0, duration: DURATION.SIDE_CLIP },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        [
          this.elements.slidesLeftImg[this.state.currentIndex],
          this.elements.slidesRightImg[this.state.currentIndex],
        ],
        { xPercent: 0 },
        {
          xPercent: (index) =>
            index === 0 ? -TRANSFORM.SIDE_MOVEMENT : TRANSFORM.SIDE_MOVEMENT,
          duration: DURATION.SIDE_CLIP,
        },
        TIMING.SIDE_DELAY
      )
      .set(this.elements.slidesLeftHeading[nextIndex].chars[0]?.parentElement,  { opacity: 1 }, TIMING.SIDE_DELAY)
      .set(this.elements.slidesRightHeading[nextIndex].chars[0]?.parentElement, { opacity: 1 }, TIMING.SIDE_DELAY)
      .fromTo(
        this.elements.slidesLeftHeading[nextIndex].chars,
        {
          yPercent: nextIndex % 2 ? -TRANSFORM.TEXT_OFFSET : TRANSFORM.TEXT_OFFSET,
        },
        {
          yPercent: 0,
          stagger: { from: 'end', each: TIMING.TEXT_STAGGER },
          duration: DURATION.TEXT,
        },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        this.elements.slidesRightHeading[nextIndex].chars,
        {
          yPercent: nextIndex % 2 ? TRANSFORM.TEXT_OFFSET : -TRANSFORM.TEXT_OFFSET,
        },
        {
          yPercent: 0,
          stagger: { from: 'start', each: TIMING.TEXT_STAGGER },
          duration: DURATION.TEXT,
        },
        TIMING.TEXT_RIGHT_DELAY
      )
      .add(() => {
        gsap.set(
          [this.elements.slidesLeft[nextIndex], this.elements.slidesRight[nextIndex]],
          { clipPath: null }
        );
      });
  }

  createBackwardTimeline() {
    const { DURATION, TIMING, TRANSFORM } = ANIMATION;
    const nextIndex = wrapIndex(this.state.currentIndex - 1, this.state.totalSlides);
    this.tl
      .set(
        [
          this.elements.slidesCenter[nextIndex],
          this.elements.slidesRight[nextIndex],
          this.elements.slidesLeft[nextIndex],
        ],
        { clipPath: 'inset(0% 0% 0% 0%)' }
      )
      .fromTo(
        this.elements.slidesCenter[this.state.currentIndex],
        { clipPath: 'inset(0% 0% 0% 0%)' },
        {
          clipPath: 'inset(50% 50% 50% 50%)',
          duration: DURATION.MIDDLE_CLIP + 0.25,
        },
        TIMING.SIDE_DELAY + 0.55
      )
      .fromTo(
        this.elements.slidesCenterImg[nextIndex],
        { scale: TRANSFORM.SCALE },
        { scale: 1, duration: DURATION.SCALE },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        [
          this.elements.slidesLeft[this.state.currentIndex],
          this.elements.slidesRight[this.state.currentIndex],
        ],
        { clipPath: 'inset(0% 0% 0% 0%)' },
        {
          clipPath: (index) =>
            index === 0 ? 'inset(0% 0% 0% 100%)' : 'inset(0% 100% 0% 0%)',
          duration: DURATION.SIDE_CLIP - 0.25,
        },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        [
          this.elements.slidesLeftImg[this.state.currentIndex],
          this.elements.slidesRightImg[this.state.currentIndex],
        ],
        { xPercent: 0 },
        {
          xPercent: (index) =>
            index === 0 ? TRANSFORM.SIDE_MOVEMENT : -TRANSFORM.SIDE_MOVEMENT,
          duration: DURATION.SIDE_CLIP - 0.25,
        },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        [
          this.elements.slidesLeftImg[nextIndex],
          this.elements.slidesRightImg[nextIndex],
        ],
        {
          xPercent: (index) =>
            index === 0 ? -TRANSFORM.SIDE_MOVEMENT : TRANSFORM.SIDE_MOVEMENT,
        },
        { xPercent: 0, duration: DURATION.SIDE_CLIP - 0.25 },
        TIMING.SIDE_DELAY
      )
      .set(this.elements.slidesLeftHeading[nextIndex].chars[0]?.parentElement,  { opacity: 1 }, TIMING.SIDE_DELAY)
      .set(this.elements.slidesRightHeading[nextIndex].chars[0]?.parentElement, { opacity: 1 }, TIMING.SIDE_DELAY)
      .fromTo(
        this.elements.slidesLeftHeading[nextIndex].chars,
        {
          yPercent: nextIndex % 2 ? -TRANSFORM.TEXT_OFFSET : TRANSFORM.TEXT_OFFSET,
        },
        {
          yPercent: 0,
          stagger: { from: 'end', each: TIMING.TEXT_STAGGER },
          duration: DURATION.TEXT,
        },
        TIMING.SIDE_DELAY
      )
      .fromTo(
        this.elements.slidesRightHeading[nextIndex].chars,
        {
          yPercent: nextIndex % 2 ? TRANSFORM.TEXT_OFFSET : -TRANSFORM.TEXT_OFFSET,
        },
        {
          yPercent: 0,
          stagger: { from: 'start', each: TIMING.TEXT_STAGGER },
          duration: DURATION.TEXT,
        },
        TIMING.TEXT_RIGHT_DELAY
      )
      .add(() => {
        gsap.set(
          [this.elements.slidesLeft[nextIndex], this.elements.slidesRight[nextIndex]],
          { clipPath: null }
        );
      });
  }

  goToSlide(nextIndex, direction) {
    if (this.state.isAnimating || nextIndex === this.state.currentIndex) return;
    this.state.isAnimating = true;
    this.state.direction = direction;
    this.createSlideAnimation(nextIndex);
  }

  setupInteraction() {
    // On mobile portrait, skip Observer entirely — cards handle navigation
    const isPortrait = window.innerHeight > window.innerWidth * (6 / 5);
    if (isPortrait) {
      this.isReleased = true;
      gsap.set('.slideshow-hero', { pointerEvents: 'none' });
      return;
    }

    this.observer = Observer.create({
      target: this.container,
      type: 'wheel,touch,pointer',
      wheelSpeed: -1,
      onDown: () => {
        // wheelSpeed:-1 inverted: onDown = user scrolls UP → previous slide
        if (!this.state.isAnimating && this.state.currentIndex > 0) {
          this.goToSlide(this.state.currentIndex - 1, -1);
        }
      },
      onUp: () => {
        // wheelSpeed:-1 inverted: onUp = user scrolls DOWN → next slide or release
        if (!this.state.isAnimating) {
          if (this.state.currentIndex === this.state.totalSlides - 1) {
            this.release();
          } else {
            this.goToSlide(this.state.currentIndex + 1, 1);
          }
        }
      },
      tolerance: 10,
      preventDefault: true,
    });
  }

  setupScrollLock() {
    // On mobile portrait, no scroll lock at all
    const isPortrait = window.innerHeight > window.innerWidth * (6 / 5);
    if (isPortrait) {
      return;
    }

    // If page loaded with scroll not at top (e.g. browser refresh),
    // skip hero lock and let the user scroll freely
    if (window.scrollY > 10) {
      this.isReleased = true;
      this.canReengage = true;
      this.observer.disable();
      gsap.set('.slideshow-hero', { pointerEvents: 'none' });
    } else {
      // Lock page scroll while slider is active
      lenis.stop();
    }

    // Re-engage slider when user scrolls back to top
    lenis.on('scroll', ({ scroll }) => {
      if (this.isReleased && this.canReengage && scroll <= 1) {
        this.engage();
      }
    });

  }

  release(callback) {
    if (this.isReleased) return;
    this.isReleased = true;
    this.canReengage = false;
    this.observer.disable();
    gsap.set('.slideshow-hero', { pointerEvents: 'none', position: 'relative' });
    lenis.start();
    // Prevent immediate re-engage from scroll=0 initial callback
    gsap.delayedCall(0.5, () => {
      this.canReengage = true;
    });
    if (callback) callback();
  }

  engage() {
    if (!this.isReleased) return;
    this.isReleased = false;
    this.canReengage = false;
    gsap.set('.slideshow-hero', { pointerEvents: '', position: 'sticky' });
    lenis.stop();
    this.observer.enable();
  }
}

/* ============================================
   INIT SLIDESHOW
   ============================================ */

let slideshowManager = null;
const slideshowContainer = document.querySelector('[data-slideshow="container"]');
if (slideshowContainer) {
  slideshowManager = new SlideshowManager();
  slideshowManager.init();
}

/* ---------- HERO HOME — intro prima slide ---------- */
(function () {
  var hero = document.querySelector('.slideshow-hero');
  if (!hero) return;

  var leftHeading  = hero.querySelector('[data-slideshow="slide-right-heading"]');
  var rightHeading = hero.querySelector('[data-slideshow="slide-left-heading"]');
  var exploreCta   = hero.querySelector('[data-slideshow="slide-explore-container"]');

  // opacity:0 è già garantita dal CSS (.page-home .slide_content-heading).
  // Il CSS è render-blocking → mai visibili prima dell'animazione.
  if (exploreCta) gsap.set(exploreCta, { opacity: 0, y: 10 });

  function runIntro() {
    // GSAP setta inline style opacity:1 che sovrascrive la regola CSS
    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    if (leftHeading)  { gsap.set(leftHeading,  { y: 24 }); tl.to(leftHeading,  { opacity: 1, y: 0, duration: 1.1 }, 0.1); }
    if (rightHeading) { gsap.set(rightHeading, { y: 24 }); tl.to(rightHeading, { opacity: 1, y: 0, duration: 1.1 }, 0.3); }
    if (exploreCta)   tl.to(exploreCta, { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }, 0.55);
  }

  window.addEventListener('preloader-done', runIntro, { once: true });
})();

/* ============================================
   HERO MOBILE CARDS — Swipe + BG crossfade
   ============================================ */

class HeroMobileCards {
  constructor() {
    const hero = document.querySelector('.slideshow-hero');
    if (!hero || !hero.classList.contains('hero--portrait')) return;

    this.track = hero.querySelector('.hero-mobile__cards-track');
    this.cards = gsap.utils.toArray(hero.querySelectorAll('.hero-mobile__card'));
    this.bgLayers = hero.querySelector('.hero-mobile__bg-layers');
    this.counterNum = hero.querySelector('.hero-mobile__num');

    if (!this.track || this.cards.length === 0) return;

    this.total = this.cards.length;
    this.current = 0;
    this.cardWidth = 0;
    this.gap = 10;

    this.buildBackgrounds(hero);
    this.measure();
    this.initSwipe();

    window.addEventListener('resize', () => this.measure());
  }

  // Build fullscreen background layers from product images
  buildBackgrounds(hero) {
    // After extractContainers, wraps are inside .left-container and .right-container
    const leftImgs = hero.querySelectorAll('.left-container [data-slideshow="slide-left-wrap"] img');
    const rightImgs = hero.querySelectorAll('.right-container [data-slideshow="slide-right-wrap"] img');
    // Slide 1: left-wrap img (siero-viso-biondina) = leftImgs[0]
    // Slide 2: right-wrap img (prodotto-vecchia) = rightImgs[1]
    // Slide 3: left-wrap img (crema-viso) = leftImgs[2]
    const bgSources = [
      leftImgs[0],
      rightImgs[1],
      leftImgs[2],
    ];

    this.bgImgs = [];
    bgSources.forEach((srcImg, i) => {
      if (!srcImg) return;
      const img = document.createElement('img');
      img.src = srcImg.getAttribute('src') || '';
      img.srcset = srcImg.getAttribute('srcset') || '';
      img.sizes = '100vw';
      img.alt = '';
      img.draggable = false;
      img.loading = 'eager';
      img.style.opacity = i === 0 ? '1' : '0';
      // Also copy picture sources (avif/webp) if available
      const picture = srcImg.closest('picture');
      if (picture) {
        const newPicture = document.createElement('picture');
        picture.querySelectorAll('source').forEach(src => {
          const clone = src.cloneNode(true);
          clone.sizes = '100vw';
          newPicture.appendChild(clone);
        });
        newPicture.appendChild(img);
        newPicture.style.position = 'absolute';
        newPicture.style.inset = '0';
        newPicture.style.width = '100%';
        newPicture.style.height = '100%';
        this.bgLayers.appendChild(newPicture);
      } else {
        this.bgLayers.appendChild(img);
      }
      this.bgImgs.push(img);
    });
  }

  measure() {
    if (this.cards.length === 0) return;
    this.cardWidth = this.cards[0].offsetWidth;
  }

  goTo(index) {
    if (index === this.current) return;
    const prev = this.current;
    this.current = index;

    // Animate card track
    gsap.to(this.track, {
      x: -index * (this.cardWidth + this.gap),
      duration: 0.4,
      ease: 'power2.out',
    });

    // Crossfade backgrounds
    if (this.bgImgs[prev]) gsap.to(this.bgImgs[prev], { opacity: 0, duration: 0.5 });
    if (this.bgImgs[index]) gsap.to(this.bgImgs[index], { opacity: 1, duration: 0.5 });

    // Update counter
    if (this.counterNum) {
      this.counterNum.textContent = String(index + 1).padStart(2, '0');
    }
  }

  initSwipe() {
    let startX = 0;
    let startY = 0;
    let startTrackX = 0;
    let dragging = false;
    let decided = false;

    const wrap = this.track.parentElement;

    wrap.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTrackX = gsap.getProperty(this.track, 'x') || 0;
      dragging = false;
      decided = false;
      gsap.killTweensOf(this.track);
    }, { passive: true });

    wrap.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        decided = true;
        dragging = Math.abs(dx) > Math.abs(dy);
      }
      if (!dragging) return;
      e.preventDefault();

      const newX = startTrackX + dx;
      const maxX = 0;
      const minX = -(this.total - 1) * (this.cardWidth + this.gap);
      const clamped = Math.max(minX - 40, Math.min(maxX + 40, newX)); // rubber band
      gsap.set(this.track, { x: clamped });
    }, { passive: false });

    wrap.addEventListener('touchend', (e) => {
      if (!dragging) return;
      dragging = false;

      const dx = e.changedTouches[0].clientX - startX;
      const threshold = this.cardWidth * 0.2;
      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? this.current + 1 : this.current - 1;
      } else {
        target = this.current;
      }
      target = Math.max(0, Math.min(target, this.total - 1));
      this.goTo(target);
    }, { passive: true });
  }
}

// Init mobile hero cards after slideshow is built
const heroMobileUI = document.querySelector('.hero-mobile-ui');
if (heroMobileUI) {
  // Wait a tick for portrait detection to run
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      new HeroMobileCards();
    });
  });
}

/* ============================================
   TELESCOPE ZOOM — BRAND SECTION (CORRETTO)
   ============================================ */

class TelescopeZoom {
  constructor() {
    this.container = document.querySelector('#brand');
    this.scene = document.querySelector('#brand .brand__scene');
    if (!this.container || !this.scene) return;

    this.media = this.scene.querySelector('.brand__media');
    this.backImg = this.scene.querySelector('.brand__media-back img');
    this.smallImages = this.scene.querySelectorAll('.brand__images img');
    this.titleLeft = this.scene.querySelector('.brand__title-left');
    this.titleRight = this.scene.querySelector('.brand__title-right');
    this.init();
  }

  init() {
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.container,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1.2,
      },
    });

    this.animate();
  }

  animate() {
    gsap.set(this.smallImages, {
      transformStyle: 'preserve-3d',
      backfaceVisibility: 'hidden',
      force3D: true,
    });

    // Media starts invisible and tiny
    gsap.set(this.media, { scale: 0, opacity: 0 });

    // All animations complete at 0.75 (75% of scroll) — last 25% is hold/breathing room
    const end = 0.75;

    // 1. Media fades in instantly on first scroll
    this.timeline.to(this.media, {
      opacity: 1,
      duration: 0.08,
      ease: 'none',
    }, 0);

    // 2. Media container scales up
    this.timeline.to(this.media, {
      scale: 0.9,
      duration: end,
      ease: 'none',
    }, 0);

    // 3. Background depth effect
    this.timeline.to(this.backImg, {
      scale: 1.2,
      duration: end,
      ease: 'none',
    }, 0);

    // 4. Small floating images fly away in perspective
    this.timeline.to(this.smallImages, {
      z: '150vh',
      duration: end,
      ease: 'none',
      stagger: { amount: 0.15, from: 'center' },
    }, 0);

    // 5. Title splits completely off-screen
    this.timeline.to(this.titleLeft, {
      x: '-55vw',
      duration: end,
      ease: 'none',
    }, 0);

    this.timeline.to(this.titleRight, {
      x: '55vw',
      duration: end,
      ease: 'none',
    }, 0);
  }
}

new TelescopeZoom();

/* ============================================
   LINEA STORY — Unified Narrative Block
   ============================================ */

class LineaStory {
  constructor() {
    this.section = document.querySelector('#linea-story');
    if (!this.section) return;

    this.type = this.section.querySelector('.linea-story__type');
    this.pill = this.section.querySelector('.linea-story__pill');
    this.animTexts = this.section.querySelectorAll('.linea-story__anim');
    this.textBefore = this.section.querySelectorAll('.linea-story__text-before');
    this.copy = this.section.querySelector('.linea-story__copy');
    this.title = this.section.querySelector('.linea-story__title');

    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;

    if (this.isMobile) {
      this.initMobile();
    } else {
      this.initExpand();
      this.initCopyLines();
      this.initGiantTitle();
    }
  }

  /* ============================================
     MOBILE: Sequential scroll-linked reveal
     Phase 1 → Title | Phase 2 → Photo | Phase 3 → Copy
     ============================================ */
  initMobile() {
    /* Phase 1: Title — hidden initially, fade-in + slide-up on scroll */
    if (this.type) {
      gsap.set(this.type, { opacity: 0, y: 40 });
      gsap.to(this.type, {
        opacity: 1,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: this.section,
          start: 'top 80%',
          end: 'top 50%',
          scrub: 1.2,
        },
      });
    }

    /* Phase 2: Pill (photo) — clip-path reveal, starts after title */
    if (this.pill) {
      gsap.set(this.pill, {
        clipPath: 'inset(12% 12% 12% 12%)',
        opacity: 0,
      });
      gsap.to(this.pill, {
        clipPath: 'inset(0% 0% 0% 0%)',
        opacity: 1,
        ease: 'sine.inOut',
        scrollTrigger: {
          trigger: this.pill,
          start: 'top 90%',
          end: 'top 55%',
          scrub: 1.2,
        },
      });
    }

    /* Phase 3: Copy lines — fade-in + slide-up, per-line triggers */
    if (this.copy) {
      const copySplit = new SplitType(this.copy, { types: 'lines' });
      if (copySplit.lines && copySplit.lines.length) {
        copySplit.lines.forEach((line) => {
          gsap.fromTo(line,
            { y: 30, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              ease: 'none',
              scrollTrigger: {
                trigger: line,
                start: 'top 85%',
                end: 'top 45%',
                scrub: 1.5,
              },
            }
          );
        });
      }
    }

    /* Phase 4: Giant decorative "Dafne" — simple opacity fade (no SplitType) */
    if (this.title) {
      gsap.fromTo(this.title,
        { opacity: 0 },
        {
          opacity: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: this.copy || this.pill || this.section,
            start: 'bottom 90%',
            end: 'bottom 50%',
            scrub: 1.5,
          },
        }
      );
    }

  }

  /* ============================================
     DESKTOP: Existing animations (unchanged)
     ============================================ */

  /* --- Expanding pill animation (direct property tween) --- */
  initExpand() {
    if (!this.type || !this.pill) return;

    const pillInner = this.pill.querySelector('.linea-story__pill-inner');
    const expand = this.type.querySelector('.linea-story__expand');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.type,
        start: 'top 85%',
        end: 'center center',
        scrub: 1.2,
      },
    });

    tl.to(this.pill, { width: 600, maxWidth: '90vw', ease: 'sine.inOut' }, 0);

    if (pillInner) {
      tl.to(pillInner, { width: 600, maxWidth: '90vw', ease: 'sine.inOut' }, 0);
    }

    if (expand) {
      tl.to(expand, { gap: '0.5rem', ease: 'sine.inOut' }, 0);
    }
  }

  /* --- Copy: SplitType lines — scrub-linked reveal --- */
  initCopyLines() {
    if (!this.copy) return;

    this.copySplit = new SplitType(this.copy, { types: 'lines' });
    if (!this.copySplit.lines || !this.copySplit.lines.length) return;

    this.copySplit.lines.forEach((line) => {
      gsap.fromTo(line,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: line,
            start: 'top 60%',
            end: 'top 20%',
            scrub: 1.5,
          },
        }
      );
    });
  }

  /* --- Giant "Dafne" chars — scrub-linked reveal --- */
  initGiantTitle() {
    if (!this.title) return;

    this.titleSplit = new SplitType(this.title, { types: 'chars' });
    if (!this.titleSplit.chars || !this.titleSplit.chars.length) return;

    gsap.fromTo(this.titleSplit.chars,
      { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.05,
        ease: 'none',
        scrollTrigger: {
          trigger: this.title,
          start: 'top 50%',
          end: 'top 10%',
          scrub: 1.5,
        },
      }
    );
  }
}

new LineaStory();

/* ============================================
   PRODOTTI — BOTTLE CAROUSEL (Split Layering)
   ============================================ */

class ProdottiCarousel {
  constructor() {
    this.section = document.querySelector('#prodotti');
    if (!this.section) return;

    this.track = this.section.querySelector('.prodotti__track');
    this.slides = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__slide'));
    this.bgs = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__bg'));
    this.bgImgs = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__bg-img'));
    this.bottleImgs = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__bottle-img'));
    this.slideInfos = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__slide-info'));
    this.indicatorNum = this.section.querySelector('.prodotti__indicator-num');
    this.previews = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__preview'));

    this.current = 0;
    this.total = this.slides.length;
    this.slideWidth = window.innerWidth;

    this.initPreviews();
    this.init();
  }

  initPreviews() {
    const self = this;
    this.previews.forEach((prev, i) => {
      prev.addEventListener('click', () => {
        self.snapTo(i);
      });
    });
  }

  updatePreviewActive(idx) {
    this.previews.forEach((prev, i) => {
      prev.classList.toggle('prodotti__preview--active', i === idx);
    });
  }

  init() {
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
    this.updateVisuals();
    if (this.isMobile) {
      this.initMobileSwipe();
    } else {
      this.initScrollDriven();
    }
  }

  initMouseDrag() {
    const self = this;
    let startX = 0;
    let startTrackX = 0;
    let dragging = false;

    this.section.addEventListener('mousedown', (e) => {
      if (e.target.closest('a, button')) return;
      startX = e.clientX;
      startTrackX = gsap.getProperty(self.track, 'x');
      dragging = true;
      self.section.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const newX = startTrackX + dx;
      const clamped = Math.max(-(self.total - 1) * self.slideWidth, Math.min(0, newX));
      gsap.set(self.track, { x: clamped });
      self.updateVisuals();
    });

    window.addEventListener('mouseup', (e) => {
      if (!dragging) return;
      dragging = false;
      self.section.style.cursor = '';

      const dx = e.clientX - startX;
      const threshold = self.slideWidth * 0.15;
      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? self.current + 1 : self.current - 1;
      } else {
        target = Math.round(-gsap.getProperty(self.track, 'x') / self.slideWidth);
      }
      target = Math.max(0, Math.min(target, self.total - 1));

      self.snapTo(target);
    });
  }

  initScrollDriven() {
    const self = this;
    const wrap = document.querySelector('#prodotti-wrap');
    const totalSlides = this.total;

    // Piecewise mapping: transition → dead zone → transition → dead zone
    // Each segment as [startRaw, endRaw, startSlide, endSlide]
    const segments = [
      [0.00, 0.38, 0, 1],   // transition: slide 1 → 2
      [0.38, 0.46, 1, 1],   // dead zone: slide 2 (8%)
      [0.46, 0.84, 1, 2],   // transition: slide 2 → 3
      [0.84, 0.92, 2, 2],   // dead zone: slide 3 (8%)
      [0.92, 1.00, 2, 2],   // buffer finale
    ];

    function mapProgress(raw) {
      for (let i = 0; i < segments.length; i++) {
        const [rStart, rEnd, sStart, sEnd] = segments[i];
        if (raw <= rEnd) {
          if (sStart === sEnd) return sStart; // dead zone
          const t = (raw - rStart) / (rEnd - rStart);
          return sStart + t * (sEnd - sStart);
        }
      }
      return totalSlides - 1;
    }

    ScrollTrigger.create({
      trigger: wrap,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0,
      onUpdate(st) {
        const wrapH = wrap.offsetHeight;
        const vh = window.innerHeight;
        const stickyStart = vh / (wrapH - vh);
        const raw = Math.max(0, (st.progress - stickyStart) / (1 - stickyStart));
        const progress = mapProgress(Math.min(raw, 1));
        const idx = Math.round(progress);
        gsap.set(self.track, { x: -progress * self.slideWidth });
        self.updateVisuals();

        if (idx !== self.current) {
          self.current = idx;
          if (self.indicatorNum) {
            self.indicatorNum.textContent = String(idx + 1).padStart(2, '0');
          }
          self.updatePreviewActive(idx);
        }
      },
    });

    // Store references for swipe
    this._wrap = wrap;
    this._segments = segments;
    this._stickyStart = null; // computed dynamically

    window.addEventListener('resize', () => {
      this.slideWidth = window.innerWidth;
      ScrollTrigger.refresh();
    });

    // Add horizontal swipe on mobile
    if (window.matchMedia('(max-width: 1024px)').matches) {
      this.initSwipe(wrap, segments);
    }
  }

  /* --- Mobile: standalone horizontal swipe with infinite loop --- */

  initMobileSwipe() {
    const self = this;
    const totalWidth = this.total * this.slideWidth;
    let startX = 0;
    let startY = 0;
    let startTrackX = 0;
    let dragging = false;
    let decided = false;

    // Reposition slides so the closest wrapped copy is always visible
    function wrapSlides() {
      const viewPos = -gsap.getProperty(self.track, 'x');
      self.slides.forEach((slide, i) => {
        const base = i * self.slideWidth;
        let bestOffset = 0;
        let bestDist = Math.abs(base - viewPos);
        for (const off of [-totalWidth, totalWidth]) {
          const d = Math.abs(base + off - viewPos);
          if (d < bestDist) { bestDist = d; bestOffset = off; }
        }
        gsap.set(slide, { x: bestOffset });
      });
    }

    // Update visuals with loop-aware indices
    function updateLoop() {
      wrapSlides();
      const trackX = gsap.getProperty(self.track, 'x');
      const rawProgress = -trackX / self.slideWidth;
      const progress = ((rawProgress % self.total) + self.total) % self.total;
      const floor = Math.floor(progress) % self.total;
      const ceil = (floor + 1) % self.total;
      const frac = progress - Math.floor(progress);

      // Crossfade pill background images
      self.bgImgs.forEach((img, i) => {
        let o = 0;
        if (frac < 0.001) o = i === floor ? 1 : 0;
        else if (i === floor) o = 1 - frac;
        else if (i === ceil) o = frac;
        gsap.set(img, { opacity: o });
      });

      // Crossfade full-screen bg colors
      self.bgs.forEach((bg, i) => {
        let o = 0;
        if (frac < 0.001) o = i === floor ? 1 : 0;
        else if (i === floor) o = 1 - frac;
        else if (i === ceil) o = frac;
        gsap.set(bg, { opacity: o });
      });

      // Bottle transforms + text with wrap-aware positions
      const viewCenter = self.slideWidth / 2;
      self.slides.forEach((slide, i) => {
        const slideOffset = parseFloat(gsap.getProperty(slide, 'x')) || 0;
        const slideCenter = i * self.slideWidth + self.slideWidth / 2 + trackX + slideOffset;
        const distRaw = (slideCenter - viewCenter) / self.slideWidth;
        const distNorm = Math.min(Math.abs(distRaw), 1);

        let bottleParallax = distRaw > 0 ? distRaw * self.slideWidth * -0.5 : 0;
        const bottleScaleX = 1 - distNorm * 0.19;
        const bottleScaleY = 1 - distNorm * 0.375;

        gsap.set(self.bottleImgs[i], {
          xPercent: -50, yPercent: -50,
          transformOrigin: 'center center',
          x: bottleParallax, y: 0,
          scaleX: bottleScaleX, scaleY: bottleScaleY, opacity: 1,
        });

        const textOpacity = gsap.utils.clamp(0, 1, 1 - distNorm * 1.8);
        const textY = distNorm * 25;
        gsap.set(self.slideInfos[i], { opacity: textOpacity, y: textY });
      });
    }

    this.section.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTrackX = gsap.getProperty(self.track, 'x');
      dragging = false;
      decided = false;
    }, { passive: true });

    this.section.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (!decided && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        decided = true;
        dragging = Math.abs(dx) > Math.abs(dy);
      }
      if (!dragging) return;
      e.preventDefault();
      gsap.set(self.track, { x: startTrackX + dx * 1.8 });
      updateLoop();
    }, { passive: false });

    this.section.addEventListener('touchend', (e) => {
      if (!dragging) return;
      dragging = false;

      const dx = e.changedTouches[0].clientX - startX;
      const threshold = self.slideWidth * 0.2;
      const trackX = gsap.getProperty(self.track, 'x');
      const rawIdx = -trackX / self.slideWidth;

      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? Math.ceil(rawIdx) : Math.floor(rawIdx);
      } else {
        target = Math.round(rawIdx);
      }

      gsap.to(self.track, {
        x: -target * self.slideWidth,
        duration: 0.4,
        ease: 'power2.out',
        onUpdate: updateLoop,
        onComplete: () => {
          // Normalize position to stay within [0, total-1] range
          const norm = ((target % self.total) + self.total) % self.total;
          gsap.set(self.track, { x: -norm * self.slideWidth });
          self.slides.forEach(s => gsap.set(s, { x: 0 }));
          self.current = norm;
          if (self.indicatorNum) {
            self.indicatorNum.textContent = String(norm + 1).padStart(2, '0');
          }
          self.updatePreviewActive(norm);
          updateLoop();
        },
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      this.slideWidth = window.innerWidth;
    });
  }

  /* --- Desktop: horizontal drag to move carousel (with ScrollTrigger sync) --- */

  initSwipe(wrap, segments) {
    const self = this;
    let startX = 0;
    let startY = 0;
    let startTrackX = 0;
    let dragging = false;
    let decided = false;

    this.section.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTrackX = gsap.getProperty(self.track, 'x');
      dragging = false;
      decided = false;
    }, { passive: true });

    this.section.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      if (!decided && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        decided = true;
        dragging = Math.abs(dx) > Math.abs(dy);
        if (dragging) lenis.stop(); // block vertical scroll while dragging
      }

      if (!dragging) return;
      e.preventDefault();

      // Move track with amplified drag (1.8x) for snappier feel
      const newX = startTrackX + dx * 1.8;
      const clamped = Math.max(-(self.total - 1) * self.slideWidth, Math.min(0, newX));
      gsap.set(self.track, { x: clamped });
      self.updateVisuals();
    }, { passive: false });

    this.section.addEventListener('touchend', (e) => {
      if (!dragging) return;
      dragging = false;
      lenis.start();

      const dx = e.changedTouches[0].clientX - startX;
      const threshold = self.slideWidth * 0.2;
      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? self.current + 1 : self.current - 1;
      } else {
        target = Math.round(-gsap.getProperty(self.track, 'x') / self.slideWidth);
      }
      target = Math.max(0, Math.min(target, self.total - 1));

      // Animate track to snap position
      gsap.to(self.track, {
        x: -target * self.slideWidth,
        duration: 0.4,
        ease: 'power2.out',
        onUpdate: () => self.updateVisuals(),
      });

      self.current = target;
      if (self.indicatorNum) {
        self.indicatorNum.textContent = String(target + 1).padStart(2, '0');
      }

      // Sync page scroll to match the new slide
      const deadZoneCenters = [0, 0.42, 0.88];
      const rawTarget = deadZoneCenters[target];
      const wrapH = wrap.offsetHeight;
      const vh = window.innerHeight;
      const stickyStart = vh / (wrapH - vh);
      const stProgress = rawTarget * (1 - stickyStart) + stickyStart;
      const scrollTarget = wrap.offsetTop + stProgress * (wrapH - vh);

      lenis.scrollTo(scrollTarget, { duration: 0.01, immediate: true });
    }, { passive: true });
  }

  /* --- Real-time crossfade + progressive transforms --- */

  updateVisuals() {
    const trackX = gsap.getProperty(this.track, 'x');
    const progress = Math.max(0, Math.min(-trackX / this.slideWidth, this.total - 1));
    const floor = Math.floor(progress);
    const ceil = Math.min(floor + 1, this.total - 1);
    const frac = progress - floor;

    // Crossfade pill background images
    this.bgImgs.forEach((img, i) => {
      let o = 0;
      if (floor === ceil) o = i === floor ? 1 : 0;
      else if (i === floor) o = 1 - frac;
      else if (i === ceil) o = frac;
      gsap.set(img, { opacity: o });
    });

    // Crossfade full-screen background colors
    this.bgs.forEach((bg, i) => {
      let o = 0;
      if (floor === ceil) o = i === floor ? 1 : 0;
      else if (i === floor) o = 1 - frac;
      else if (i === ceil) o = frac;
      gsap.set(bg, { opacity: o });
    });

    // Progressive transforms: scale + opacity + parallax (always frontal)
    const viewCenter = this.slideWidth / 2;

    this.slides.forEach((slide, i) => {
      const slideCenter = i * this.slideWidth + this.slideWidth / 2 + trackX;
      const distRaw = (slideCenter - viewCenter) / this.slideWidth;
      const distNorm = Math.min(Math.abs(distRaw), 1);

      // --- Bottle: asymmetric parallax + scaleY rotation ---
      let bottleParallax;
      if (distRaw > 0) {
        // Right neighbor: pull so bottle center sits at right edge → half-clipped
        bottleParallax = distRaw * this.slideWidth * -0.5;
      } else {
        // Current / left exit: no extra parallax, exits naturally with track
        bottleParallax = 0;
      }

      const bottleScaleX = 1 - distNorm * 0.19;                  // 1.0 → 0.81
      const bottleScaleY = 1 - distNorm * 0.375;                 // 1.0 → 0.625 (rotation)

      gsap.set(this.bottleImgs[i], {
        xPercent: -50,
        yPercent: -50,
        transformOrigin: 'center center',
        x: bottleParallax,
        y: 0,
        scaleX: bottleScaleX,
        scaleY: bottleScaleY,
        opacity: 1,
      });

      // --- Text: fade out + slight vertical push ---
      const textOpacity = gsap.utils.clamp(0, 1, 1 - distNorm * 1.8);
      const textY = distNorm * 25;

      gsap.set(this.slideInfos[i], {
        opacity: textOpacity,
        y: textY,
      });
    });
  }

  /* --- Snap to nearest slide --- */

  snapTo(index) {
    index = Math.max(0, Math.min(index, this.total - 1));
    this.current = index;

    gsap.to(this.track, {
      x: -index * this.slideWidth,
      duration: 1.1,
      ease: 'power2.inOut',
      onUpdate: () => this.updateVisuals(),
    });

    if (this.indicatorNum) {
      this.indicatorNum.textContent = String(index + 1).padStart(2, '0');
    }
    this.updatePreviewActive(index);
  }

  /* --- Sync indicator to current slide --- */

  syncIndicator() {
    const x = gsap.getProperty(this.track, 'x');
    this.current = Math.round(Math.abs(x) / this.slideWidth);
    this.current = Math.max(0, Math.min(this.current, this.total - 1));
    if (this.indicatorNum) {
      this.indicatorNum.textContent = String(this.current + 1).padStart(2, '0');
    }
    this.updatePreviewActive(this.current);
  }

  /* --- Draggable on the track (InertiaPlugin with fallback) --- */

  initDraggable() {
    const self = this;
    const hasInertia = typeof InertiaPlugin !== 'undefined';

    if (hasInertia) {
      /* ---- InertiaPlugin path: smooth inertia + snap ---- */
      Draggable.create(this.track, {
        type: 'x',
        inertia: true,
        edgeResistance: 0.85,
        resistance: 150,
        throwResistance: 1500,
        bounds: {
          minX: -(this.total - 1) * this.slideWidth,
          maxX: 0,
        },
        snap: {
          x: function (endValue) {
            return Math.round(endValue / self.slideWidth) * self.slideWidth;
          },
        },
        minimumMovement: 5,
        zIndexBoost: false,
        onDrag() {
          self.updateVisuals();
        },
        onThrowUpdate() {
          self.updateVisuals();
        },
        onThrowComplete() {
          self.updateVisuals();
          self.syncIndicator();
        },
      });
    } else {
      /* ---- Fallback: manual velocity-based snap ---- */
      let startX = 0;
      let startTime = 0;

      Draggable.create(this.track, {
        type: 'x',
        edgeResistance: 0.65,
        bounds: {
          minX: -(this.total - 1) * this.slideWidth,
          maxX: 0,
        },
        minimumMovement: 5,
        zIndexBoost: false,
        onDragStart() {
          startX = this.x;
          startTime = Date.now();
        },
        onDrag() {
          self.updateVisuals();
        },
        onDragEnd() {
          const deltaX = this.x - startX;
          const elapsed = Math.max(Date.now() - startTime, 1);
          const velocity = Math.abs(deltaX) / elapsed; // px/ms
          const threshold = self.slideWidth * 0.15;     // 15% of viewport

          let target;
          if (Math.abs(deltaX) > threshold || velocity > 0.3) {
            target = deltaX < 0 ? self.current + 1 : self.current - 1;
          } else {
            target = Math.round(-this.x / self.slideWidth);
          }

          self.snapTo(target);
        },
      });
    }
  }

  /* --- Keyboard navigation --- */

  initKeyboard() {
    document.addEventListener('keydown', (e) => {
      const rect = this.section.getBoundingClientRect();
      if (rect.top > window.innerHeight || rect.bottom < 0) return;
      if (e.key === 'ArrowRight') this.snapTo(this.current + 1);
      else if (e.key === 'ArrowLeft') this.snapTo(this.current - 1);
    });
  }

  /* --- Horizontal wheel --- */

  initWheel() {
    let cooldown = false;
    this.section.addEventListener('wheel', (e) => {
      if (cooldown) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 20) {
        cooldown = true;
        if (e.deltaX > 0) this.snapTo(this.current + 1);
        else this.snapTo(this.current - 1);
        setTimeout(() => { cooldown = false; }, 600);
      }
    }, { passive: true });
  }
}

new ProdottiCarousel();

/* --- Prodotti slide-1: testi intro on-scroll --- */
(function () {
  var section  = document.querySelector('#prodotti');
  if (!section) return;
  var wrap     = document.querySelector('#prodotti-wrap') || section;
  var slide0   = section.querySelector('.prodotti__slide');
  var info0    = slide0 && slide0.querySelector('.prodotti__slide-info');
  var infoEls  = info0 ? Array.from(info0.querySelectorAll('.prodotti__label, .prodotti__name, .prodotti__price, .prodotti__explore-cta')) : [];
  var infoText = info0 && info0.querySelector('.info-testo');
  if (!infoEls.length) return;

  var bgStatic = section.querySelector('.prodotti__bg-static');

  var done = false;
  var fallback;

  function reveal() {
    if (done) return;
    done = true;
    clearTimeout(fallback);
    var tl = gsap.timeline();
    if (bgStatic) tl.fromTo(bgStatic, { opacity: 0 }, { opacity: 1, duration: 1.1, ease: 'power3.out' }, 0);
    tl.fromTo(infoEls,  { opacity: 0, y: 28 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.65, ease: 'power3.out' }, 0.2);
    if (infoText) tl.fromTo(infoText, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }, '+=0.4');
  }

  function check() {
    if (done) return;
    var rect = wrap.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) reveal();
  }

  /* Fallback: se l'animazione non scatta entro 2s, mostra tutto */
  fallback = setTimeout(reveal, 2000);

  check();
  lenis.on('scroll', check);
})();

/* ============================================
   LINES — CLICK-TO-LAYOUT (GSAP FLIP)
   ============================================ */

const linesSection = document.querySelector('#lines-section');
if (linesSection) {
  const linesGrid = linesSection.querySelector('.lines-grid');
  const introTexts = gsap.utils.toArray(linesGrid.querySelectorAll('.lines-oh > span'));
  const images = gsap.utils.toArray(linesGrid.querySelectorAll('.lines-grid__image'));
  const imageHomes = images.map(img => img.parentElement); // each .lines-slot
  const contentWrap = linesSection.querySelector('.lines-content-wrap');
  const contents = gsap.utils.toArray(linesSection.querySelectorAll('.lines-content'));
  const contentRowImages = gsap.utils.toArray(linesSection.querySelectorAll('.lines-content__row--image'));
  const contentBackCtrls = gsap.utils.toArray(linesSection.querySelectorAll('.lines-content__back'));

  // Collect content text spans per panel
  const contentTexts = contents.map(
    c => gsap.utils.toArray(c.querySelectorAll('.lines-oh > span'))
  );

  // Animation guard
  let isAnimating = false;
  let entranceKilled = false;

  // Kill entrance scrub — frees transforms for Flip
  function killEntrance() {
    if (entranceKilled) return;
    entranceKilled = true;
    // Force timeline to end state (all elements revealed)
    entranceTl.progress(1);
    // Kill ScrollTrigger and timeline (no pin-spacer to worry about)
    entranceTl.scrollTrigger && entranceTl.scrollTrigger.kill();
    entranceTl.kill();
    // Clear inline styles left by scrub so Flip reads clean computed values
    gsap.set(introTexts, { clearProps: 'xPercent,yPercent' });
    gsap.set(images, { clearProps: 'scale,opacity' });
    gsap.set(imageInners, { clearProps: 'scale' });
  }

  // Set initial hidden states for entrance
  gsap.set(introTexts, {
    yPercent: (_, target) => {
      const dir = target.dataset.direction;
      if (dir === 'top') return -101;
      if (dir === 'bottom') return 101;
      return 0;
    },
    xPercent: (_, target) => {
      const dir = target.dataset.direction;
      if (dir === 'left') return -101;
      if (dir === 'right') return 101;
      return 0;
    },
  });

  const imageInners = gsap.utils.toArray(linesGrid.querySelectorAll('.lines-grid__image-inner'));
  gsap.set(images, { scale: 0.8, opacity: 0 });
  gsap.set(imageInners, { scale: 1.2 });

  // Entrance animation — pinned on desktop, simple trigger on mobile
  const isDesktop = window.matchMedia('(min-width: 1025px)').matches;

  const entranceTl = gsap.timeline({
    onComplete: isDesktop ? undefined : () => killEntrance(),
    scrollTrigger: isDesktop
      ? {
          trigger: linesSection,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 1,
        }
      : {
          trigger: linesSection,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
  });

  entranceTl.to(introTexts, {
    xPercent: 0,
    yPercent: 0,
    duration: 1.1,
    ease: 'power2.out',
    stagger: 0.08,
  });

  entranceTl.to(images, {
    scale: 1,
    opacity: 1,
    duration: 1,
    ease: 'power2.out',
    stagger: 0.15,
  }, '-=0.8');

  entranceTl.to(imageInners, {
    scale: 1,
    duration: 1.2,
    ease: 'power2.out',
    stagger: 0.15,
  }, '<');

  // Open content function (1:1 replica of LinesToLayout-main)
  const openContent = (image, position) => {
    if (isAnimating) return;
    isAnimating = true;

    // Decouple entrance scrub — free transforms for Flip
    killEntrance();

    // Stop Lenis scroll while content is open
    lenis.stop();
    // Make content wrap a fixed viewport overlay and raise section z-index
    contentWrap.classList.add('lines-content-wrap--fixed');
    linesSection.style.zIndex = '9999';
    // Cursore scuro per sfondo chiaro del pannello
    var cursorEl = document.getElementById('cursor');
    if (cursorEl) cursorEl.classList.add('Cursor--dark');

    const otherImageInners = images
      .filter(el => el !== image)
      .map(el => el.querySelector('.lines-grid__image-inner'));

    gsap.timeline({
      defaults: { duration: 1.1, ease: 'power4.inOut' },
      onComplete: () => {
        isAnimating = false;
      },
    })
    .addLabel('start', 0)
    .add(() => {
      const rectBefore = image.getBoundingClientRect();
      const state = Flip.getState(image);
      contentRowImages[position].appendChild(image);
      const rectAfter = image.getBoundingClientRect();
      console.log('[FLIP OPEN] before:', rectBefore, 'after:', rectAfter,
        'deltaX:', rectAfter.left - rectBefore.left,
        'deltaY:', rectAfter.top - rectBefore.top,
        'scaleW:', rectAfter.width / rectBefore.width);
      Flip.from(state, {
        duration: 1.2,
        ease: 'power4.inOut',
        absolute: true,
      });

      linesGrid.classList.add('lines-grid--close');
      contents[position].classList.add('lines-content--open');

      gsap.set(contentBackCtrls[position], { xPercent: 20, opacity: 0 });
      gsap.set(contentTexts[position], { yPercent: 101 });
    }, 'start')
    .to([introTexts, otherImageInners], {
      xPercent: (_, target) => {
        switch (target.dataset.direction) {
          case 'right': return 101;
          case 'left': return -101;
          default: return 0;
        }
      },
      yPercent: (_, target) => {
        switch (target.dataset.direction) {
          case 'top': return -101;
          case 'bottom': return 101;
          default: return 0;
        }
      },
    }, 'start')
    .addLabel('content', 'start+=0.7')
    .to(contentTexts[position], {
      ease: 'expo',
      yPercent: 0,
    }, 'content')
    .to(contentBackCtrls[position], {
      ease: 'expo',
      xPercent: 0,
      opacity: 1,
    }, 'content');
  };

  // Close content function
  const closeContent = (image, position) => {
    if (isAnimating) return;
    isAnimating = true;

    const otherImageInners = images
      .filter(el => el !== image)
      .map(el => el.querySelector('.lines-grid__image-inner'));

    gsap.timeline({
      defaults: { duration: 1.1, ease: 'power4.inOut' },
      onComplete: () => {
        linesGrid.classList.remove('lines-grid--close');
        contents[position].classList.remove('lines-content--open');
        gsap.set(contents[position], { clearProps: 'opacity' });
        contentWrap.classList.remove('lines-content-wrap--fixed');
        isAnimating = false;
        // Restore section z-index
        linesSection.style.zIndex = '';
        // Ripristina cursore chiaro
        var cursorEl = document.getElementById('cursor');
        if (cursorEl) cursorEl.classList.remove('Cursor--dark');
        // Re-enable Lenis scroll
        lenis.start();
      },
    })
    .addLabel('start', 0)
    .to(contentTexts[position], {
      duration: 0.8,
      yPercent: 101,
    }, 'start')
    .to(contentBackCtrls[position], {
      duration: 0.8,
      xPercent: 20,
      opacity: 0,
    }, 'start')
    .add(() => {
      const rectBefore = image.getBoundingClientRect();
      const state = Flip.getState(image);
      imageHomes[position].appendChild(image);
      const rectAfter = image.getBoundingClientRect();
      console.log('[FLIP CLOSE] before:', rectBefore, 'after:', rectAfter,
        'deltaX:', rectAfter.left - rectBefore.left,
        'deltaY:', rectAfter.top - rectBefore.top,
        'scaleW:', rectAfter.width / rectBefore.width);
      Flip.from(state, {
        duration: 1.2,
        ease: 'power4.inOut',
        absolute: true,
      });
    }, 'start')
    .to(contents[position], {
      opacity: 0,
      duration: 0.4,
    }, 'start+=0.4')
    .addLabel('intro', 'start+=0.6')
    .to(introTexts, {
      ease: 'expo',
      xPercent: 0,
      yPercent: 0,
    }, 'intro')
    .to(otherImageInners, {
      ease: 'power3.out',
      duration: 1.3,
      xPercent: 0,
      yPercent: 0,
    }, 'intro');
  };

  // Click handlers
  images.forEach((image, position) => {
    image.addEventListener('click', () => openContent(image, position));
  });

  contentBackCtrls.forEach((ctrl, position) => {
    ctrl.addEventListener('click', () => closeContent(images[position], position));
  });
}

/* ============================================
   SECTION REVEALS (below hero)
   ============================================ */

const revealElements = gsap.utils.toArray([
  '.section__label',
  '.section__title',
  '.contact__email',
]);

revealElements.forEach((el) => {
  gsap.from(el, {
    y: 60,
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
    scrollTrigger: {
      trigger: el,
      start: 'top 85%',
      toggleActions: 'play none none none',
    },
  });
});

/* --- Marquee infinite scroll --- */

const marqueeTrack = document.querySelector('.marquee__track');
if (marqueeTrack) {
  const trackWidth = marqueeTrack.scrollWidth / 2;
  gsap.to('.marquee__track', {
    x: -trackWidth,
    duration: 20,
    ease: 'none',
    repeat: -1,
  });
}

/* ============================================
   FOOTER ANIMATIONS
   ============================================ */

// Split footer text elements into lines
const footerTextElements = document.querySelectorAll('[data-footer-text]');

if (footerTextElements.length > 0) {
  // Split all footer text elements into lines
  footerTextElements.forEach((element) => {
    new SplitType(element, { types: 'lines' });
  });

  // Wrap lines in overflow containers for reveal effect
  const footerLines = document.querySelectorAll('.footer [data-footer-text] .line');
  footerLines.forEach((line) => {
    const wrapper = document.createElement('div');
    wrapper.style.overflow = 'hidden';
    line.parentNode.insertBefore(wrapper, line);
    wrapper.appendChild(line);
  });

  // Animate footer email
  const footerEmail = document.querySelector('.footer__email');
  if (footerEmail) {
    const lines = footerEmail.querySelectorAll('.line');
    gsap.from(lines, {
      yPercent: 100,
      opacity: 0,
      duration: 1.2,
      stagger: 0.1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: footerEmail,
        start: 'bottom bottom',
        toggleActions: 'play none none none',
      },
    });
  }

  // Animate footer bottom
  const footerBottom = document.querySelector('.footer__bottom');
  if (footerBottom) {
    const bottomElements = footerBottom.querySelectorAll('[data-footer-text]');
    bottomElements.forEach((el, index) => {
      const lines = el.querySelectorAll('.line');
      gsap.from(lines, {
        yPercent: 100,
        opacity: 0,
        duration: 1,
        delay: index * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: footerBottom,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      });
    });
  }
}


/* ============================================
   LINES SECTION — Mobile Parallax & Reveals
   (≤1024px only — does NOT affect desktop)
   ============================================ */

(function linesMobileInit() {
  if (!window.matchMedia('(max-width: 1024px)').matches) return;

  var section = document.querySelector('#lines-section');
  if (!section) return;

  var grid = section.querySelector('.lines-grid');
  if (!grid) return;

  var rows = gsap.utils.toArray(grid.querySelectorAll('.lines-grid__row'));
  var allOhSpans = gsap.utils.toArray(grid.querySelectorAll('.lines-oh > span'));
  var allImages = gsap.utils.toArray(grid.querySelectorAll('.lines-grid__image'));
  var allImageInners = gsap.utils.toArray(grid.querySelectorAll('.lines-grid__image-inner'));

  /* Kill the desktop entrance ScrollTrigger for #lines-section */
  ScrollTrigger.getAll().forEach(function(st) {
    if (st.trigger === section) {
      if (st.animation) {
        st.animation.progress(1);
        st.animation.kill();
      }
      st.kill();
    }
  });

  /* Clear only GSAP-set transforms (preserve inline background-image!) */
  gsap.set(allOhSpans, { clearProps: 'transform' });
  gsap.set(allImages, { clearProps: 'transform,opacity' });
  gsap.set(allImageInners, { clearProps: 'transform' });

  /* Scale image-inners for parallax headroom (30% extra) */
  gsap.set(allImageInners, { scale: 1.3 });

  /* --- Per-row reveal: fade-in + slide-up (20px), slow & elegant --- */
  rows.forEach(function(row) {
    var texts = gsap.utils.toArray(row.querySelectorAll('.lines-grid__text'));
    var slots = gsap.utils.toArray(row.querySelectorAll('.lines-slot'));

    gsap.set(texts, { opacity: 0, y: 20 });
    gsap.set(slots, { opacity: 0, y: 20 });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: row,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    });

    tl.to(slots, {
      opacity: 1,
      y: 0,
      duration: 1.4,
      ease: 'power2.out',
      stagger: 0.15,
    }, 0);

    tl.to(texts, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: 'power2.out',
      stagger: 0.1,
    }, 0.35);
  });

  /* --- Liquid parallax on image-inners (organic depth) --- */
  gsap.utils.toArray(grid.querySelectorAll('.lines-slot')).forEach(function(slot) {
    var inner = slot.querySelector('.lines-grid__image-inner');
    if (!inner) return;

    gsap.fromTo(inner,
      { yPercent: -15 },
      {
        yPercent: 15,
        ease: 'none',
        scrollTrigger: {
          trigger: slot,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6,
        },
      }
    );
  });
})();


/* ---------- FOOTER — cursor dark ---------- */
(function () {
  var footer = document.querySelector('.footer');
  var cursor = document.getElementById('cursor');
  if (!footer || !cursor) return;

  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom bottom',
    onEnter:     function () { cursor.classList.add('Cursor--dark'); },
    onLeaveBack: function () { cursor.classList.remove('Cursor--dark'); },
  });
})();


/* ---------- PRODOTTI CURSOR — rotating EXPLORE ring ---------- */
(function () {
  var overlays = document.querySelectorAll('#prodotti .prodotti__img-overlay');
  if (!overlays.length) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  var el = document.createElement('div');
  el.id = 'prodotti-cursor';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML =
    '<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg">' +
    '<defs><path id="prd-c-path" d="M65,65 m-52,0 a52,52 0 1,1 104,0 a52,52 0 1,1 -104,0"/></defs>' +
    '<text><textPath href="#prd-c-path">EXPLORE \u2022 EXPLORE \u2022 EXPLORE \u2022\u00A0</textPath></text>' +
    '</svg>' +
    '<svg class="prodotti-cursor__arrow" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<line x1="1.5" y1="11.5" x2="11.5" y2="1.5" stroke="#ffebcf" stroke-width="1.4" stroke-linecap="round"/>' +
    '<path d="M5.5 1.5 H11.5 V7.5" stroke="#ffebcf" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  document.body.appendChild(el);

  var cursorEl = document.getElementById('cursor');

  window.addEventListener('mousemove', function (e) {
    el.style.left = e.clientX + 'px';
    el.style.top  = e.clientY + 'px';
  }, { passive: true });

  overlays.forEach(function (overlay) {
    overlay.addEventListener('mouseenter', function () {
      el.classList.add('is-visible');
      if (cursorEl) cursorEl.classList.add('Cursor--prodotti');
    });
    overlay.addEventListener('mouseleave', function () {
      el.classList.remove('is-visible');
      if (cursorEl) cursorEl.classList.remove('Cursor--prodotti');
    });
  });
})();

/* ============================================
   COOKIE BANNER ANIMATION — home page
   ============================================ */
(function () {
  // Gestisce race condition: banner può apparire prima o dopo preloader-done
  var preloaderDoneFired = false;
  var pendingShow = null;

  window.addEventListener('preloader-done', function () {
    preloaderDoneFired = true;
    if (pendingShow) { pendingShow(); pendingShow = null; }
  }, { once: true });

  function showBanner(banner) {
    gsap.fromTo(banner,
      { opacity: 0, y: 18 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', clearProps: 'transform' }
    );
  }

  function waitForBanner(onFound) {
    var el = document.querySelector('.shopify-pc__banner__dialog');
    if (el) { gsap.set(el, { opacity: 0 }); onFound(el); return; }
    var obs = new MutationObserver(function (_, observer) {
      el = document.querySelector('.shopify-pc__banner__dialog');
      if (el) { observer.disconnect(); gsap.set(el, { opacity: 0 }); onFound(el); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  var isFirstVisit = !localStorage.getItem('nymphai_preloader_seen');

  waitForBanner(function (banner) {
    if (isFirstVisit) {
      if (preloaderDoneFired) {
        setTimeout(function () { showBanner(banner); }, 500);
      } else {
        pendingShow = function () { setTimeout(function () { showBanner(banner); }, 500); };
      }
    } else {
      setTimeout(function () { showBanner(banner); }, 1500);
    }
  });
})();
